import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Radio,
  TextField,
} from "@mui/material";
import axios from "axios";
import { Checkbox } from "@mui/material";
import { ToWords } from "to-words";
import TermsAndConditionsModal from "./TermsAndConditionsModal";

const toWords = new ToWords({
  localeCode: "en-IN",
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
  },
});
const POFooter = ({
  handleGeneratePO,
  handleUpdatePO,
  setPOData,
  isPOData,
  isViewMode,
  isEditMode,
  errors,
}) => {
  const [isAllTermsAndConditions, setAllTermsAndConditons] = useState([]);
  const [openTCModal, setOpenTCModal] = useState(false);
  const [openCreateTCModal, setOpenCreateTCModal] = useState(false);
  const [disableButtonCheck, setDisableButtonCheck] = useState(false);

  const [newTC, setNewTC] = useState({
    title: "",
    description: "",
  });
  const [isAllPaymentTerms, setAllPaymentTerms] = useState([]);
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(
    isPOData?.paymentTermId,
  );

  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [openCreatePaymentModal, setOpenCreatePaymentModal] = useState(false);

  const [newPaymentTerm, setNewPaymentTerm] = useState({
    title: "",
    description: "",
  });

  const serverURL = process.env.REACT_APP_URL;
  const poAmountWords = toWords.convert(Number(isPOData?.poAmount || 0), {
    currency: true,
  });

  const cgstWords = toWords.convert(Number(isPOData?.totalCGSTAmount || 0), {
    currency: true,
  });
  const igstWords = toWords.convert(Number(isPOData?.totalIGSTAmount || 0), {
    currency: true,
  });

  const sgstWords = toWords.convert(Number(isPOData?.totalSGSTAmount || 0), {
    currency: true,
  });
  const cessWords = toWords.convert(Number(isPOData?.totalCESSAmount || 0), {
    currency: true,
  });
  const token = localStorage.getItem("token");
  const getAllTermsAndConditions = async () => {
    try {
      const response = await axios.get(
        `${serverURL}/termsAndConditions/allTerms`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response?.data?.success) {
        setAllTermsAndConditons(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching in terms and conditions:", error);
    }
  };
  const getAllPaymentTerms = async () => {
    try {
      const response = await axios.get(`${serverURL}/paymentTerms/getAll`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        setAllPaymentTerms(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (isAllPaymentTerms.length && isPOData?.paymentTermId) {
      const payment = isAllPaymentTerms.find(
        (item) =>
          item._id === (isPOData.paymentTermId._id || isPOData.paymentTermId),
      );

      setSelectedPaymentTerm(payment || null);
    }
  }, [isAllPaymentTerms, isPOData?.paymentTermId]);

  useEffect(() => {
    if (!isViewMode) {
      getAllTermsAndConditions();
      getAllPaymentTerms();
    }
  }, []);
  const createTermsCondition = async () => {
    setDisableButtonCheck(true);
    try {
      const res = await axios.post(
        `${serverURL}/termsAndConditions/create`,
        newTC,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const createdTerm = res.data.data;

      setPOData((prev) => ({
        ...prev,
        termsAndConditionsId: [
          ...(prev.termsAndConditionsId || []),
          createdTerm._id,
        ],
      }));
      setOpenCreateTCModal(false);
      // setOpenTCModal(false);

      setNewTC({
        title: "",
        description: "",
      });

      getAllTermsAndConditions();
    } catch (err) {
      console.error(err);
    }
  };
  const createPaymentTerm = async () => {
    try {
      const res = await axios.post(
        `${serverURL}/paymentTerms/create`,
        newPaymentTerm,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const createdPayment = res.data.data;

      setSelectedPaymentTerm(createdPayment);

      setPOData((prev) => ({
        ...prev,
        paymentTermId: createdPayment._id,
      }));

      setOpenCreatePaymentModal(false);
      setOpenPaymentModal(false);

      setNewPaymentTerm({
        title: "",
        description: "",
      });

      getAllPaymentTerms();
    } catch (error) {
      console.log(error);
    }
  };

  const toggleTerm = (id) => {
    setPOData((prev) => {
      const exists = prev.termsAndConditionsId?.some(
        (term) => (term?._id || term).toString() === id.toString(),
      );

      return {
        ...prev,
        termsAndConditionsId: exists
          ? prev.termsAndConditionsId.filter(
              (term) => (term?._id || term).toString() !== id.toString(),
            )
          : [...(prev.termsAndConditionsId || []), id],
      };
    });
  };
  return (
    <div className=" px-7 py-2 bg-white">
      {/* Summary */}
      <div className="grid gap-8 p-6 lg:grid-cols-2">
        {/* Left Side */}
        <div className="space-y-4">
          {isPOData?.amounts_in_words.map((ele) => {
            return (
              <>
                <div>
                  <div className="flex justify-between">
                    <span className=" text-[18px] font-medium text-[#000000] leading-6 w-[220px]">
                      {ele?.name}
                    </span>
                    <span className=" text-[18px] font-normal text-[#000000] leading-6">
                      ₹ {ele?.value}
                    </span>
                  </div>
                </div>
              </>
            );
          })}
          {/* <div>
            <div className="flex justify-between">
              <span className=" font-medium text-[#000000] leading-6">
                PO Amount:
              </span>
              <span className=" font-normal text-[#000000] leading-6">
                ₹ {isPOData?.poAmount > 0 ? poAmountWords : "0.00"}
              </span>
            </div>
          </div>
          {isPOData?.isIGST ? (
            <div>
              <div className="flex justify-between">
                <span className=" font-medium text-[#000000] leading-6">
                  IGST:
                </span>
                <span className=" font-normal text-[#000000] leading-6">
                  ₹ {isPOData?.totalIGSTAmount > 0 ? igstWords : "0.00"}
                </span>
              </div>
            </div>
          ) : (
            <>
              <div>
                <div className="flex justify-between">
                  <span className=" font-medium text-[#000000] leading-6">
                    CGST:
                  </span>
                  <span className=" font-normal text-[#000000] leading-6">
                    ₹ {isPOData?.totalCGSTAmount > 0 ? cgstWords : "0.00"}
                  </span>
                </div>
              </div>

              <div>
                <div className="flex justify-between">
                  <span className=" font-medium text-[#000000] leading-6">
                    SGST:
                  </span>
                  <span className=" font-normal text-[#000000] leading-6">
                    ₹ {isPOData?.totalSGSTAmount > 0 ? sgstWords : "0.00"}
                  </span>
                </div>
              </div>
            </>
          )} */}

          {/* <div>
            {isPOData?.totalCESSAmount > 0 && (
              <div className="flex justify-between">
                <span className=" font-medium text-[#000000] leading-6">
                  CESS:
                </span>
                <span className=" font-normal text-[#000000] leading-6">
                  ₹ {isPOData.totalCESSAmount > 0 ? cessWords : "0.00"}
                </span>
              </div>
            )}
          </div> */}
        </div>

        {/* Right Side */}
        <div className="space-y-5">
          <div className="flex justify-between  ">
            <span className=" text-[18px] font-medium text-[#000000] leading-6">
              Total (before Tax):
            </span>
            <span className="text-[18px]">
              ₹ {isPOData?.total_before_tax_amount}
            </span>
          </div>

          {/* Tax Table */}
          <div className="overflow-x-auto">
            <table className="w-full border border-gray-300 text-center">
              <thead>
                <tr className="bg-gray-50">
                  <th className="border p-3">
                    <span className=" font-medium text-[#000000] leading-6">
                      {" "}
                      CGST
                    </span>
                  </th>

                  <th className="border p-3">
                    <span className=" font-medium text-[#000000] leading-6">
                      SGST
                    </span>
                  </th>

                  <th className="border p-3">
                    <span className=" font-medium text-[#000000] leading-6">
                      IGST
                    </span>
                  </th>

                  <th className="border p-3">
                    <span className=" font-medium text-[#000000] leading-6">
                      CESS
                    </span>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td className="border p-3">
                    ₹ {isPOData?.total_cgst?.toFixed(2) || "0.00"}
                  </td>
                  <td className="border p-3">
                    ₹ {isPOData?.total_sgst?.toFixed(2) || "0.00"}
                  </td>
                  <td className="border p-3">
                    ₹{" "}
                    {isPOData?.total_igst
                      ? isPOData?.total_igst?.toFixed(2) || "0.00"
                      : "0.00"}
                  </td>
                  <td className="border p-3">
                    ₹ {isPOData?.total_cess?.toFixed(2) || "0.00"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="text-[18px] font-medium text-[#000000] leading-6">
                Total Tax:
              </span>
              <span className="text-[18px]">
                ₹ {isPOData?.total_tax_amount?.toFixed(2) || "0.00"}
              </span>
            </div>

            <div className="flex justify-between">
              <span className=" text-[18px] font-medium text-[#000000] leading-6">
                Total (after Tax):
              </span>
              <span className="text-[18px]">
                ₹ {isPOData?.total_after_tax_amount?.toFixed(2) || "0.00"}
              </span>
            </div>

            <div className="flex justify-between ">
              <span className=" text-[18px] font-medium text-[#000000] leading-6">
                Grand Total:
              </span>
              <span className="text-[18px]">
                ₹ {isPOData?.total_after_tax_amount?.toFixed(2) || "0.00"}
              </span>
            </div>
            {isPOData?.advance_to_pay > 0 ? (
              <div className="flex justify-between ">
                <span className=" text-[16px] font-medium text-[#000000] leading-6">
                  Advance :
                </span>
                <span className="text-[18px]">
                  ₹ {isPOData?.advance_to_pay?.toFixed(2) || "0.00"}
                </span>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>

      {/* Signature */}
      <div className="border-t p-8">
        <div className="flex min-h-[150px] flex-col items-end justify-between">
          <span className="text-right text-[18px] ">
            For Signthought Solutions Private Limited
          </span>
          <div
            style={{
              background: "#009eff",
              height: "130px",
              width: "130px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "20px",
              marginTop: "10px",
            }}
          >
            <img
              src="/assests/pixell white logo.png"
              alt="pixell Logo"
              width={70}
              height={70}
            />
          </div>

          <span className="mt-3 text-[18px]">Authorized Signatory</span>
        </div>
      </div>

      {/* <div className="h-[1px] w-[101%] bg-gray-300 mb-3 "></div> */}
    </div>
  );
};

export default POFooter;
